module.exports = {
	env: {
		//API: "http://localhost:5000",
		API: "https://futurelive-api.eventapp.app",
		PORT: "8002",
		JWT_SECRET: "ikapparneca",
		HASH_SECRET: "abcdefg"
	}
}